import { render, staticRenderFns } from "./InactiveTag.vue?vue&type=template&id=77a3332d&scoped=true"
import script from "./InactiveTag.vue?vue&type=script&lang=ts"
export * from "./InactiveTag.vue?vue&type=script&lang=ts"
import style0 from "./InactiveTag.vue?vue&type=style&index=0&id=77a3332d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a3332d",
  null
  
)

export default component.exports